export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getButtonState() {
    const { firstMealAfter, hormonalContraceptions, bonePain, fallingAsleep } = this.formValues

    this.showButton = !!(firstMealAfter && (hormonalContraceptions || bonePain) && fallingAsleep)
  },
})
